import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Menu, X } from 'lucide-react'
import axios from 'axios'
import { trackEvent, EVENTS } from '@/lib/analytics'

// Shared marketing-page header. One header for every public page, extracted
// from the decluttered landing nav (2026-08-24 design-system pass).
// Logged out: quiet "Log in" plus one navy "Start free" CTA.
// Logged in: single "Open workspace" button.
// `source` feeds the signup analytics event so each page keeps its own
// attribution (landing_nav, pricing_nav, contact_nav, ...).

export default function SiteHeader({ source = 'site_nav' }) {
  const go = useNavigate()
  const [isLoggedIn, setIsLoggedIn] = useState(
    typeof window !== 'undefined' && !!localStorage.getItem('session_token')
  )
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, { withCredentials: true })
      .then(() => setIsLoggedIn(true))
      .catch(() => {
        if (!localStorage.getItem('session_token')) setIsLoggedIn(false)
      })
  }, [])

  const handleStartFree = () => {
    trackEvent(EVENTS.SIGNUP_STARTED, { source, cta: 'start_free', method: 'cta_click' })
    go('/login?signup=true')
  }

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <button onClick={() => go('/')} aria-label="BragBox home" className="flex items-center">
            <img src="/assets/bragbox-hero.png" alt="BragBox" className="h-10 md:h-12" />
          </button>
          <div className="hidden md:flex items-center gap-3">
            {isLoggedIn ? (
              <Button onClick={() => go('/app')} style={{ backgroundColor: '#1F2A44', color: 'white' }}>
                Open workspace
              </Button>
            ) : (
              <>
                <Button variant="ghost" onClick={() => go('/login')}>Log in</Button>
                <Button onClick={handleStartFree} style={{ backgroundColor: '#1F2A44', color: 'white' }}>
                  Start free
                </Button>
              </>
            )}
          </div>
          <div className="md:hidden">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 rounded-md text-gray-700" aria-label="Toggle menu">
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 flex flex-col gap-2">
            {isLoggedIn ? (
              <Button className="w-full" onClick={() => { go('/app'); setMobileMenuOpen(false) }} style={{ backgroundColor: '#1F2A44', color: 'white' }}>
                Open workspace
              </Button>
            ) : (
              <>
                <Button variant="ghost" className="w-full justify-start" onClick={() => { go('/login'); setMobileMenuOpen(false) }}>
                  Log in
                </Button>
                <Button className="w-full" onClick={() => { handleStartFree(); setMobileMenuOpen(false) }} style={{ backgroundColor: '#1F2A44', color: 'white' }}>
                  Start free
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  )
}
